import React, { useEffect, useState } from "react";
import { Table, Image } from "antd";
import { fetchAllTransactions } from "../../../service/admin/transactionService";
import BreadcrumbComponent from "../../CssComponents/BreadCrumbComponents";

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);

  const breadcrumbItems = [
    { name: "Dashboard", url: "/superadmin/dashboard" },
    { name: "Transactions" },
  ];

  useEffect(() => {
    const loadTransactions = async () => {
      const data = await fetchAllTransactions();

      setTransactions(data);
      console.log(data, "transction data we get from here");
    };

    loadTransactions();
  }, []);

  const columns = [
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "User ID",
      dataIndex: "uid",
      key: "uid",
    },
    {
      title: "Item ID",
      dataIndex: "itemId",
      key: "itemId",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (timestamp) => new Date(timestamp).toLocaleString(),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Proof",
      dataIndex: "proofUrls",
      key: "proofUrls",
      render: (urls) => (
        <div className="flex gap-2">
          {urls.map((url, index) => (
            <Image
              preview
              key={index}
              src={url}
              alt={`Proof ${index + 1}`}
              className="!h-20 !w-24 object-cover object-top overflow-hidden rounded"
            />
          ))}
        </div>
      ),
    },
  ];

  return (
    <div className="p-6 flex flex-col gap-4">
      <BreadcrumbComponent items={breadcrumbItems} />
      <Table
        dataSource={transactions}
        columns={columns}
        rowKey="id"
        scroll={{ x: "max-content" }}
        className="shadow-md w-full overflow-auto"
      />
    </div>
  );
};

export default Transactions;
